import * as React from 'react'
import { StyleSheet, Text } from 'react-native'
import currency from 'currency.js'
import { FixedText } from '@components/FixedText'
import * as Colors from '@themes/Colors'
import Fonts from '@themes/Fonts'

export function DollarTag({ value }: { value: string | number | currency }) {
  return (
    <FixedText lineHeight={1}>
      <Text style={styles.text}>{currency(value).format()}</Text>
    </FixedText>
  )
}

const styles = StyleSheet.create({
  text: {
    flexDirection: 'row',
    fontSize: 17,
    fontFamily: Fonts.type.alternateBold,
    fontWeight: 'bold',
    color: Colors.primary,
  },
})
